module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "body"
  }, [_c('section', {
    attrs: {
      "aria-labelledby": "ch3",
      "epub:type": "chapter",
      "role": "doc-chapter"
    }
  }, [_c('header', [_c('h1', {
    staticClass: "VST"
  }, [_c('span', {
    attrs: {
      "aria-label": "4",
      "id": "pg_4",
      "role": "doc-pagebreak"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/contents#c_ch3",
      "id": "ch3",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_c('i', [_vm._v("There are moments in time")])])])])])]), _vm._v(" "), _c('blockquote', [_c('p', {
    staticClass: "V"
  }, [_vm._v("that your mind will never allow you to forget.")]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_vm._v("A fragrance, a nostalgic scent that you")]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_vm._v("identify "), _c('i', [_vm._v("with one person")]), _vm._v(" aids in mental")]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_vm._v("recall. "), _c('i', [_vm._v("Autumn is a trigger for me.")]), _vm._v(" I smell the")]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_vm._v("heaviness of the ombre leaves as they begin")]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_vm._v("their great descent, and the memories cascade")]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_vm._v("like raindrops from heaven. "), _c('i', [_vm._v("A kiss on the")])]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_c('i', [_vm._v("bank of a swollen river whilst my toes sink")])]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_c('i', [_vm._v("into sticky mud that feels like chocolate")])]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_c('i', [_vm._v("frosting. Broad shoulders below me, bent")])]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_c('i', [_vm._v("knees, trembling like the strings of a guitar—")])]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_c('i', [_vm._v("asking if I will be his for a lifetime.")]), _vm._v(" There")]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_vm._v("was no exaggeration in his tone, and I wish I")]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_vm._v("had known then that he meant every rehearsed")]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_vm._v("syllable, while stroking my youthful soul with")]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_vm._v("the words a naïve girl longs to hear. "), _c('i', [_vm._v("Lifetime.")])]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_vm._v("Because even after all these years, there are")]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_vm._v("days that I still feel like I belong to him—"), _c('i', [_vm._v("and")])]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_c('i', [_vm._v("he to me.")]), _vm._v(" And I shake myself awake, and remind")]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_vm._v("my lungs to breathe, because I’d rather die")]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_vm._v("than be back there, in that lifetime, "), _c('i', [_vm._v("willing")])]), _vm._v(" "), _c('p', {
    staticClass: "VSB"
  }, [_c('i', [_vm._v("myself to believe in another day.")])]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_vm._v("The thing is, I spent most of our years")]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_vm._v("together trying to find a way out. And no")]), _vm._v(" "), _c('p', {
    staticClass: "V"
  }, [_vm._v("one knew.")])]), _vm._v(" "), _c('section', {
    attrs: {
      "epub:type": "division"
    }
  }, [_c('h2', {
    staticClass: "H1"
  }, [_c('b', [_c('i', [_vm._v("It was him or me, and I decided—")])])])]), _vm._v(" "), _c('section', {
    attrs: {
      "epub:type": "division"
    }
  }, [_c('h2', {
    staticClass: "H1"
  }, [_c('b', [_c('i', [_vm._v("I wanted to live.")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ecd96f70","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/chapter3.vue
// module id = 75
// module chunks = 0